import { Box, List, ListItem, ListItemIcon } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledList = styled(List)({
  maxWidth: "100%",
  backgroundColor: "theme.palette.background.paper",
  padding: "64px 42px"
})

export const StyledListItem = styled(ListItem)({
  borderBottom: "1px solid #E0E0E0",
  borderRadius: "0 !important",
  padding: "96px 0 20px 0",
  alignItems: "flex-start !important",
  display: "flex",
  flexDirection: "column"
})

export const StyledBox = styled(Box)({
  maxWidth: "100%",
  display: "flex",
  padding: "0px"
})

export const StyledListItemIcon = styled(ListItemIcon)({
  paddingRight: "12px"
})

export const StyledGreyBox = styled(Box)({
  borderTop: "1px solid #E0E0E0"
})

export const StyledSpan = styled("span")({
  fontWeight: 600
})
